import React from 'react';
import { Modal, DatePicker, Spin } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';

import AttendanceCalendar from '../share/AttendanceCalendar';

import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';

export default class StudentAttendanceCalendarIndexPage extends React.Component {
  constructor(props) {
    super(props);

    let currentRole = CurrentRoleStore.getCurrentRole();
    this.state = {
      currentRole,
      schoolId: props.params.schoolId,
      semester: SharedTools.getCurrentSemester(),
      grades: []
    }

  }

  componentWillReceiveProps(newProps) {

  }

  componentDidMount() {
    let { schoolId, currentRole } = this.state;
    if (currentRole.associatName == "classGrade") {
      hashHistory.push(`student-attendance/schools/${schoolId}/attendance-calendar/grades/${currentRole.associatObj.id}`);
    } else {
      this.getSchoolAttendance()
    }
  }

  getSchoolAttendance() {
    let data = {
      school_id: this.state.schoolId,
      semester: this.state.semester
    }
    DataService.getSumSetGrades(data).then((res) => {
      this.setState({
        grades: res
      })
    }).catch((error) => {
      console.log(error)
    });
  }

  setGradeAttendance(gradeId) {
    let { schoolId } = this.state;
    hashHistory.push(`student-attendance/schools/${schoolId}/attendance-calendar/grades/${gradeId}`);
  }

  render() {

    return (
      <div className="student-attendance-calendar-index-page">
        {this.state.grades.map(gradeItem =>
          <div className="class-box" key={gradeItem.grade_id} onClick={this.setGradeAttendance.bind(this, gradeItem.grade_id)}>
            <div className="class-box-name" >{gradeItem.grade_name}</div>
            <div className="class-box-info" >已设置，共{gradeItem.setted}天</div>
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/StudentAttendanceCalendarIndexPage.jsx